export const changeLanguage = language => ({
  type: 'CHANGE_LANGUAGE',
  language
})
